import { useMode as useModeContext } from '../contexts/ModeContext';

export function useMode() {
  return useModeContext();
}
